import { find, forEach, map } from "lodash";
import CustomField from "../customField";
import { renderField } from "../index";
import { useDynamicFormStore } from "@stores/dynamicFormStore";

const SectionField = (props: { title: string; subField: any; metaData: any; isRequired: boolean; className: string, handleRulesOnValueChange: any}) => {
  const [modifiedFields] = useDynamicFormStore((state) => [state.modifiedFields]);
  const fieldsUnderSection: any[] | null | undefined = [];

  forEach(props.subField, (field) => {
    fieldsUnderSection.push(find(modifiedFields, { id: field }));
  });

  return (
    <div className={`${props.className}__section`}>
      <div className={`${props.className}__section__title`}>
        <span className={`${props.className}__section__title__left f14 w600`}>
          {props.title}
          <span className="supplementalFileContainer__body__required">{props.isRequired && "*"}</span>
        </span>
        {props.metaData.isMandatory && (
          <div className={`${props.className}__required f14 w400`}>
            {/* <span>*</span> */}
            <span>{props.metaData.message}</span>
          </div>
        )}
      </div>
      {map(fieldsUnderSection, (field) => {
        return <CustomField key={`${field.id}`} field={field} renderField={renderField} handleRulesOnValueChange={props.handleRulesOnValueChange} />;
      })}
    </div>
  );
};

export default SectionField;
